import styled from 'styled-components';

import { pxToRem } from '@utils/converters';

import { MAX_VISIBLE_PRESENCE_AVATARS } from './constants';
import { usePresence } from './presence-context';
import { UserAvatarList } from './user-avatar-list';

type ActionPresenceIndicatorProps = {
  id: string;
};

export const ActionPresenceIndicator = ({ id }: ActionPresenceIndicatorProps) => {
  const { actionEditors, activeUsers, currentUserId } = usePresence();

  const editorUserIds = actionEditors.get(id);
  const editors = editorUserIds
    ? activeUsers.filter((user) => editorUserIds.has(user.userId) && user.userId !== currentUserId)
    : [];

  if (editors.length === 0) {
    return null;
  }

  return (
    <Container>
      <UserAvatarList
        users={editors}
        maxVisible={MAX_VISIBLE_PRESENCE_AVATARS}
        tooltipPlacement="top"
      />
    </Container>
  );
};

const Container = styled.div({
  position: 'absolute',
  top: pxToRem(-12),
  right: pxToRem(-12),
  zIndex: 10,
  pointerEvents: 'none',
});
